import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./site/site.component').then(m => m.SiteComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./auth/auth-callback/auth-callback.component').then(m => m.AuthCallbackComponent),
  },
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./onboarding/onboarding.component').then(m => m.OnboardingComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/auth-login/auth-login.component').then(m => m.AuthLoginComponent),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./auth/auth-signup/auth-signup.component').then(m => m.AuthSignupComponent),
  },
  {
    path: 'activate',
    loadComponent: () =>
      import('./auth/auth-activate/auth-activate.component').then(m => m.AuthActivateComponent),
  },
  {
    path: 'recoverpassword',
    loadComponent: () =>
      import('./auth/auth-recovery-password/auth-recovery-password.component').then(
        m => m.AuthRecoveryPasswordComponent
      ),
  },
  {
    path: 'resetpassword',
    loadComponent: () =>
      import('./auth/auth-set-password/auth-set-password.component').then(
        m => m.AuthSetPasswordComponent
      ),
  },
  {
    path: 'servers',
    loadChildren: () => import('./servers/servers.routes').then(m => m.SERVERS_ROUTES),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'applications',
    loadChildren: () =>
      import('./applications/applications.routes').then(m => m.APPLICATIONS_ROUTES),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.routes').then(m => m.USERS_ROUTES),
    canActivate: [AuthGuard],
    data: { preload: false },
  },
  {
    path: 'appstore',
    loadChildren: () => import('./appstore/appstore.routes').then(m => m.APPSTORE_ROUTES),
    canActivate: [AuthGuard],
    data: { preload: false },
  },
  {
    path: 'material-demo',
    loadComponent: () =>
      import('./material-demo/material-demo.component').then(m => m.MaterialDemoComponent),
  },
  {
    path: 'lazy-loading-demo',
    loadComponent: () =>
      import('./shared/lazy-loading-demo/lazy-loading-demo.component').then(
        m => m.LazyLoadingDemoComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.routes').then(m => m.PROFILE_ROUTES),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES),
    canActivate: [AuthGuard],
    data: { preload: false },
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
  { path: '**', redirectTo: '/not-found' },
];
